import { useState, useMemo, useEffect } from 'react';

export interface AllocationItem {
  id: string;      // ID ของสิ่งที่ต้องการแบ่งสัดส่วน (ถ้าเป็นเงินสด อาจจะใช้คำว่า 'CASH')
  name: string;    // ชื่อที่จะแสดง
  ratio: number;   // สัดส่วนปัจจุบัน
  isCash?: boolean;// Flag บอกว่าเป็นเงินสดหรือไม่
}

export const useAllocationValidator = (initialItems: AllocationItem[]) => {
  const [items, setItems] = useState<AllocationItem[]>(initialItems);

  // เมื่อ initialItems เปลี่ยน (เช่น ดึง API เสร็จ) ให้เซ็ตค่าใหม่
  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  // คำนวณผลรวมแบบ Real-time
const totalRatio = useMemo(() => {
  const sum = items.reduce((sum, item) => sum + (Number(item.ratio) || 0), 0);
  // ปัดเศษให้เหลือ 2 ตำแหน่ง เพื่อป้องกันปัญหา 0.00000000004
  return Math.round(sum * 100) / 100;
}, [items]);

  // สัดส่วนที่เหลืออยู่
  const remainingRatio = 100 - totalRatio;

  // เงื่อนไข: ผ่านก็ต่อเมื่อรวมกันแล้วไม่เกิน 100 (ถ้าอยากบังคับให้ต้อง 100 พอดี ให้ใช้ totalRatio === 100)
  const isValid = totalRatio <= 100;
  const isOverAllocated = totalRatio > 100;

  // ฟังก์ชันสำหรับอัปเดตสัดส่วนของแต่ละ Item
  const updateRatio = (id: string, newRatio: number) => {
    setItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, ratio: newRatio } : item))
    );
  };

  return {
    items,
    totalRatio,
    remainingRatio,
    isValid,
    isOverAllocated,
    updateRatio,
  };
};